import React, { PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isAuthenticated } from '../utils/auth';
import { hasRouteAccess, getUserRolesFromToken } from '../config/routePermissions';

const ProtectedRoute: React.FC<PropsWithChildren> = ({ children }) => {
    const location = useLocation();
    const isAuthed = isAuthenticated();
    const userRoles = getUserRolesFromToken();

    // Check authentication first
    if (!isAuthed) {
        return <Navigate to='/login' replace />;
    }

    // Check role-based access using centralized function
    const hasAccess = hasRouteAccess(location.pathname, userRoles);
    if (!hasAccess) {
        // Redirect to home page if user doesn't have required role
        return <Navigate to='/' replace />;
    }

    return <>{children}</>;
};

export default ProtectedRoute;
